import styled, { css } from "styled-components";
import { PageContextUtils } from "../../../../utils/index.js";
import { Theme } from "../../../../constants/index.js";
import { ThemeUtils } from "../../../../utils/index.js";

const { currentName = Theme.Default } = PageContextUtils.getThemeData();
const MyAccountAreaFooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 3.5rem 1rem 0;
  flex-direction: column;
  flex-shrink: 0;
`;

const AppVersion = styled.span`
  margin: 0 auto 2rem;
  font-size: 1.2rem;
  font-family: ${props =>
    ThemeUtils.isVITheme()
      ? props.theme.typography.fontFamilyDemibold
      : "var(--app-default-font, Arial, sans-serif), Arial, sans-serif"};
  font-weight: 600;
  color: ${props => props.theme.colors.colorSecondary};
`;

const Separator = styled.hr`
  margin-bottom: 2rem;
  border: 1px solid ${props => props.theme.borders.borderBottomFooter};
`;

const LogoutButton = styled.button`
  width: 100%;
  height: 4rem;
  border: 0;
  cursor: pointer;
  font-family: ${props =>
    ThemeUtils.isVITheme()
      ? props.theme.typography.fontFamilyDemibold
      : props.theme.typography.fontFamilyBold};
  font-weight: 700;
  font-size: 1.4rem;
  background: ${props => props.theme.backgrounds.boxBG};
  border-radius: 1rem;
  color: ${props => props.theme.colors.textColor};
  ${props => {
    switch (currentName) {
      case Theme.MrGreen:
        return css`
          &:hover {
            color: ${props.theme.colors.textColor};
          }
        `;
      default:
        return css`
          &:hover {
            background-color: ${props =>
              props.theme.borders.borderBottomFooter};
          }
        `;
    }
  }}
`;

export { MyAccountAreaFooterWrapper, AppVersion, Separator, LogoutButton };
